import type { CodeableConcept } from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import { ORGANIZATION_TYPE } from '#src/codeSystems.ts'

export const OrganizationType = {
  SEEN_HEALTH: 'seen-health',
  EXTERNAL_PROVIDER: 'external-provider',
  REFERRAL_CHANNEL: 'referral-channel',
} as const
export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType]

export const ORGANIZATION_TYPES = {
  [OrganizationType.SEEN_HEALTH]: codeableConcept({
    system: ORGANIZATION_TYPE,
    code: OrganizationType.SEEN_HEALTH,
    display: 'Seen Health',
  }),
  [OrganizationType.EXTERNAL_PROVIDER]: codeableConcept({
    system: ORGANIZATION_TYPE,
    code: OrganizationType.EXTERNAL_PROVIDER,
    display: 'External Provider',
  }),
  [OrganizationType.REFERRAL_CHANNEL]: codeableConcept({
    system: ORGANIZATION_TYPE,
    code: OrganizationType.REFERRAL_CHANNEL,
    display: 'Referral Channel',
  }),
} satisfies Record<OrganizationType, CodeableConcept>
